import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import { AdminDeleteAProduct, AllAdminProducts } from "../utils/Api/ApiCalls";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

const Products = () => {
  const currentUser = useRecoilValue(userState);
  const [productData, setProductData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const itemsPerPage = 10;

  const [reload, setReload] = useState(false);

  const fetchAllAdminProducts = async () => {
    try {
      const response = await AllAdminProducts(currentUser?.data?.info?.id);
      console.log(response.data);
      setProductData(response.data);
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  const RemovingSingleProduct = async (id) => {
    try {
      const response = await AdminDeleteAProduct(id);
      if (response) {
        Swal.fire({
          title: "Product Deleted Successfully",
          icon: "success",
        }).then(() => {
          fetchAllAdminProducts();
        });
      }
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  useEffect(() => {
    fetchAllAdminProducts();
  }, [reload]);

  // Filter all products based on search value
  const filteredProducts = productData?.filter((props) => {
    const searchLowerCase = searchValue?.toLowerCase();
    return (
      props?.productTitle?.toLowerCase().includes(searchLowerCase) ||
      props?.category?.toLowerCase().includes(searchLowerCase)
    );
  });

  // Calculate the range of items to display on the current page from the filtered results
  const totalPages = Math.ceil(filteredProducts?.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const reversedProducts = filteredProducts?.slice().reverse();
  const currentItems = reversedProducts?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  // Handle page change
  const goToPreviousPage = (e) => {
    e.preventDefault();
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = (e) => {
    e.preventDefault();
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getPageNumbers = () => {
    const pages = [];
    const range = 2;
    let start = Math.max(1, currentPage - range);
    let end = Math.min(totalPages, currentPage + range);

    if (start > 2) {
      pages.push(1);
      if (start > 3) {
        pages.push("...");
      }
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 1) {
      if (end < totalPages - 2) {
        pages.push("...");
      }
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <section class="content-main">
      <div class="content-header">
        <div>
          <h2 class="content-title card-title">Products List</h2>
          <p>Collections of products.</p>
        </div>
        <div>
          <Link to="/add-product" class="btn btn-primary">
            <i class="text-muted material-icons md-post_add"></i>Add product
          </Link>
        </div>
      </div>
      <div class="card mb-4">
        <header class="card-header">
          <div class="row align-items-center">
            <div class="col-md-5 col-12 me-auto mb-md-0 mb-3">
              <div class="col-search">
                <form class="searchform">
                  <div class="input-group">
                    <input
                      onChange={(e) => {
                        setSearchValue(e.target.value);
                        setCurrentPage(1); // Reset to the first page after search
                      }}
                      type="text"
                      class="form-control"
                      placeholder="Search product by title"
                    />
                    <button class="btn btn-light bg" type="button">
                      <i class="material-icons md-search"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="col-md-2 col-12 me-auto mb-md-0 mb-3">
              <select
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  setCurrentPage(1); // Reset to the first page after search
                }}
                class="form-select"
              >
                <option selected disabled>
                  --Select--
                </option>
                <option value="Phones">Phones</option>
                <option value="Computers">Computers</option>
                <option value="Accessories">Accessories</option>
                <option value="Games and Console">Games and Console</option>
                <option value="Tablets">Tablets</option>
                <option value="Travel Adaptors">Travel Adaptors</option>
                <option value="Wearables">Wearables</option>
              </select>
            </div>
          </div>
        </header>

        <div class="card-body">
          {currentItems?.map((props) => (
            <article key={props.id} class="itemlist">
              <div class="row align-items-center pe-4">
                <div class="col col-check flex-grow-0">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-3 col-8 flex-grow-1 col-name">
                  <a class="itemside" href="#">
                    <div class="left">
                      <img
                        src={`https://backend.argone.ng/uploads/${props?.productImages[0].img}`}
                        class="img-sm img-thumbnail"
                        alt="Item"
                      />
                    </div>
                    <div class="info">
                      <h6 class="mb-0">{props?.productTitle}</h6>
                    </div>
                  </a>
                </div>
                <div class="col-lg-2 sol-sm-2 col-2">{props?.label}</div>
                <div class="col-lg-2 col-sm-2 col-4 col-price">
                  <span># {props?.regularPrice?.toLocaleString()}</span>
                </div>
                <div class="col-lg-2 col-sm-2 col-4 col-status">
                  <span class="badge rounded-pill alert-success">Active</span>
                </div>
                <div class="col-lg-2 col-sm-2 col-4 col-action text-end d-flex">
                  <Link to={`/edit-product/${props?.id}`}>
                    <a
                      href="#"
                      class="btn btn-sm font-sm rounded btn-brand"
                      style={{ marginRight: "8px" }}
                    >
                      <i class="material-icons md-edit"></i> Edit
                    </a>
                  </Link>

                  <a
                    onClick={() => {
                      RemovingSingleProduct(props.id);
                    }}
                    href="#"
                    class="btn btn-sm font-sm btn-light rounded"
                  >
                    <i class="material-icons md-delete_forever"></i> Delete
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>

      <div className="pagination-area mt-30 mb-50">
        <nav aria-label="Page navigation example">
          <ul className="pagination justify-content-start">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <a
                className="page-link"
                href="#"
                onClick={goToPreviousPage}
                style={{ width: "auto" }}
              >
                Previous
              </a>
            </li>
            {getPageNumbers().map((page, index) =>
              page === "..." ? (
                <li key={index} className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              ) : (
                <li
                  key={page}
                  className={`page-item ${
                    page === currentPage ? "active" : ""
                  }`}
                >
                  <a
                    className="page-link"
                    href="#"
                    onClick={() => paginate(page)}
                  >
                    {page}
                  </a>
                </li>
              )
            )}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <a
                className="page-link"
                href="#"
                onClick={goToNextPage}
                style={{ width: "auto" }}
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
};

export default Products;
